"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _he = _interopRequireDefault(require("he"));

var _transfer = _interopRequireDefault(require("./assets/transfer.gif"));

var _logo = _interopRequireDefault(require("./assets/logo.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OfferClick =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OfferClick, _React$Component);

  function OfferClick() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OfferClick);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OfferClick)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "styles", {
      wrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#509dc9',
        color: '#FFF',
        height: '100%',
        width: '100%',
        fontFamily: 'Open Sans',
        position: 'absolute'
      },
      content: {
        maxWidth: '640px',
        width: '100%',
        textAlign: 'center'
      },
      progress: {
        background: '#FFF',
        borderRadius: '10px',
        padding: '48px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly'
      },
      img: {
        verticalAlign: 'middle',
        maxWidth: '100%'
      },
      title: {
        fontFamily: 'Neusa',
        fontSize: '30px',
        fontWeight: '500',
        lineHeight: '1.2',
        letterSpacing: '1px',
        textAlign: 'center',
        color: '#ffffff',
        textTransform: 'uppercase'
      },
      bank: {
        fontSize: '20px',
        lineHeight: '1.7',
        textAlign: 'center',
        color: '#ffffff',
        margin: '0 0 8px'
      },
      lock: {
        margin: '0 0 16px'
      }
    });

    return _this;
  }

  _createClass(OfferClick, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        style: this.styles.wrap
      }, _react["default"].createElement("link", {
        href: "https://cdn.creditcards.com/auth/fonts/neusa.css",
        rel: "stylesheet"
      }), _react["default"].createElement("link", {
        href: "https://fonts.googleapis.com/css?family=Open+Sans:400,600",
        rel: "stylesheet"
      }), _react["default"].createElement("div", {
        style: this.styles.content
      }, _react["default"].createElement("div", {
        style: this.styles.title
      }, "Transferring you"), _react["default"].createElement("div", {
        style: this.styles.bank
      }, _react["default"].createElement("span", null, "to "), _react["default"].createElement("span", null, _he["default"].decode(this.props.bankName)), _react["default"].createElement("span", null, "'s "), _react["default"].createElement("span", null, _react["default"].createElement("em", null, "secure")), _react["default"].createElement("span", null, " application")), _react["default"].createElement("div", {
        style: this.styles.progress
      }, _react["default"].createElement("div", {
        style: {
          width: '187px'
        }
      }, _react["default"].createElement("img", {
        alt: "CreditCards.com",
        style: this.styles.img,
        src: _logo["default"]
      })), _react["default"].createElement("div", {
        style: {
          width: '150px'
        }
      }, _react["default"].createElement("img", {
        role: "presentation",
        style: this.styles.img,
        src: _transfer["default"]
      })), _react["default"].createElement("div", {
        style: {
          width: '191px'
        }
      }, _react["default"].createElement("img", {
        alt: this.props.cardName,
        style: this.styles.img,
        src: this.props.cardArt
      })))));
    }
  }]);

  return OfferClick;
}(_react["default"].Component);

_defineProperty(OfferClick, "propTypes", {
  bankName: _propTypes["default"].string,
  cardArt: _propTypes["default"].string,
  cardName: _propTypes["default"].string
});

var _default = OfferClick;
exports["default"] = _default;